module.exports = __webpack_public_path__ + "static/media/rubber4_seamless.c509a2db.png";